<template>
    <div
        v-if="getCurrentQuestion() > 1 || props.remainingQuestionCount > 0"
        class="survey-progress-bar-header"
        role="region"
        aria-live="polite"
        :aria-label="`Survey progress: ${Math.round(getProgress())}% complete. Question ${getCurrentQuestion()} of ${getMaxQuestionCount() || '…'}`"
    >
        <div class="survey-progress-bar-container">
            <p class="progress-text">
                <span class="current-count-text">Question {{ getCurrentQuestion() }}</span>&nbsp;of {{ getMaxQuestionCount() }}
            </p>
            <ProgressBar
                :value="getProgress()"
                :show-value="false"
                bar-color="#006cff"
                background-color="#ddd"
                class="survey-progress-bar"
                :aria-label="`Survey progress: ${Math.round(getProgress())}% complete`"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import ProgressBar from '@/components/PrimeVue/ProgressBar.vue'

interface Props {
    currentQuestion: number
    remainingQuestionCount?: number
}

const props = defineProps<Props>()
const getCurrentQuestion = () => {
    return props.currentQuestion + 1
}
const getMaxQuestionCount = () => {
    return props.remainingQuestionCount + getCurrentQuestion()
}
const getProgress = () => {
    let max = getMaxQuestionCount()
    let current = getCurrentQuestion()
    if (max < 1 || current < 1) {
        return 0
    }
    return (current / max) * 100
}
</script>

<style lang="less">
.survey-progress-bar-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 54px;
    background: #fff;
    border-bottom: 1px solid #ddd;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.survey-progress-bar-container {
    // max width of conversation is 600 with 5px padding on each side
    max-width: calc(600px - 10px + (2 * 27px));
    padding-left: 27px;
    padding-right: 27px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-top: 18px;
}
.progress-text {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 4px;
    margin-top: 18px;
    font: 700 14px Arial;
    color: #232323;
}
.current-count-text {
    color: #006cff;
}
.survey-progress-bar {
    --p-progressbar-border-radius: 100px;
    margin-bottom: 18px;
    .p-progressbar-value {
        border-radius: 100px;
    }
}
</style>
